module.exports = __webpack_public_path__ + "img/product_110.6142f26.webp";